import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import Autocomplete from '../autocomplete';
import FieldStatus from '../field-status';

import { AUTOCOMPLETE_PROPS } from '../autocomplete/types';

const defaultRules = {};

const AutocompleteField = forwardRef(
  (
    {
      rules = defaultRules,
      onChange = Function.prototype,
      onBlur = Function.prototype,
      control,
      value,
      name,
      ...otherProps
    },
    ref
  ) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    const handleChange = useCallback(
      (option) => {
        field.onChange(option?.value);

        if (onChange) onChange(option);
      },
      [field, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();

      if (onBlur) onBlur();
    }, [field, onBlur]);

    return (
      <React.Fragment>
        <Autocomplete
          {...otherProps}
          invalid={fieldState.invalid}
          onChange={handleChange}
          onBlur={handleBlur}
          defaultInputValue={field.value}
          ref={ref}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

AutocompleteField.displayName = 'AutocompleteField';
AutocompleteField.propTypes = {
  ...AUTOCOMPLETE_PROPS,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default AutocompleteField;
